module.exports = __webpack_public_path__ + "img/empilhadeiras_pag6_SMALL.866921e4.jpeg";